<template>
  <div ref="side_ads" class="side-ads ad-slot">
    <div class="ad_container">
      <div class="ad_wrapper">
        <div v-if="screen.isDesktop" id="div-gpt-ad-1556609030596-0"></div>
        <div v-else id="div-gpt-ad-1556161782064-0"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'side-ads',
  computed: {
    screen() {
      return this.$store.state.screen;
    },
  },
  mounted() {
    if (document.readyState == 'complete') {
      this.loadAds();
    } else {
      document.addEventListener(
        'scriptReady',
        () => {
          this.loadAds();
        },
        { once: true }
      );
    }
  },
  beforeDestroy() {
    googletag.cmd.push(() => {
      const slots = googletag.pubads().getSlots();
      slots.forEach((slot) => {
        const elId = slot.getSlotElementId();
        if (elId === 'div-gpt-ad-1556609030596-0' || elId === 'div-gpt-ad-1556161782064-0') {
          googletag.destroySlots([slot]);
          const el = document.getElementById(elId);
          if (el) {
            el.removeAttribute('data-slot-loaded');
          }
        }
      });
    });
  },
  methods: {
    loadAds() {
      const el = this;
      const isDesktop = this.$store.state.screen.isDesktop;
      const slotId = isDesktop ? 'div-gpt-ad-1556609030596-0' : 'div-gpt-ad-1556161782064-0';

      const adContainer = document.getElementById(slotId);
      if (!adContainer || adContainer.dataset.slotLoaded) {
        return;
      }

      googletag.cmd.push(() => {
        googletag.pubads().enableSingleRequest();
        googletag.pubads().collapseEmptyDivs();
        googletag.pubads().addEventListener('slotRenderEnded', function (event) {
          if (event.isEmpty) {
            const id = event.slot.getSlotElementId();
            if (id) {
              if (el.$refs['side_ads'] && el.$refs['side_ads'].classList.contains('ad-slot')) {
                el.$refs['side_ads'].style.display = 'none';
              }
            }
          }
        });

        const slot = googletag.defineSlot(
          isDesktop ? '/187290464/Revamp_Desktop_SideBanner' : '/187290464/Revamp_Mobile_SideBanner',
          isDesktop ? [240, 400] : [320, 50],
          slotId
        );

        if (slot) {
          slot.addService(googletag.pubads()).setCollapseEmptyDiv(true);
          googletag.enableServices();
          googletag.display(slotId);
          adContainer.dataset.slotLoaded = 'true';
        }
      });
    },
  },
};
</script>

<style lang="scss">
.ad_container {
  text-align: center;
}

.ad_wrapper {
  display: inline-block;
  position: relative;
}
</style>
